import { render, staticRenderFns } from "./ameldings.vue?vue&type=template&id=ac23b73a&scoped=true&"
import script from "./ameldings.vue?vue&type=script&lang=ts&"
export * from "./ameldings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac23b73a",
  null
  
)

export default component.exports